import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as glIdcGroups from '../../gl-idc-groups'

export const RESOURCE = {
  payload: {
    description:
      "Used to group GL expenses for an IDC base review. Generally corresponds to one or more segments of the institution's GL chartstring, such as fund/purpose and project/activity, that are relevant when functionalizing expenses for an IDC base review",
    dimension: glIdcGroups.RESOURCE.payload,
    level: 0,
    name: 'GL IDC Group',
    partialId: PartialId.Standard.create('group'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
